export { default } from './CounterBadge';
export { type CounterBadgeProps } from './CounterBadge';
